import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  styled,
  Button,
  Tooltip,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { statusStyleArray } from "../config";
import { formattedAmountWithoutAed } from "../../../utils/CommonFunction";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Statistis from "./Statistics";
import { ReactComponent as SmallDhiramIcon } from "../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../utils/CurrencyUtils";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  color: "#4D6BF6",
  textAlign: "right",
  fontFamily: "Inter Tight",
  fontSize: "14px",
  fontWeight: "500",
  boxShadow: "none !important",
  padding: "0 !important",
  minWidth: "fit-content",
  "&:hover": {
    textDecoration: "underline",
    backgroundColor: "transparent",
  },
}));

export default function ProposalDetails({ details }) {
  const navigate = useNavigate();

  const handleChange = (item) => {
    navigate("/ongoing-project", {
      state: { villa: item },
    });
  };

  const handleChange2 = (item) => {
    navigate(`/project/details/${item?.proposal_id}`);
  };

  return (
    <>
      <Statistis />
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          overflow: "none !important",
          boxShadow: "none",
          maxHeight: "70vh",
          overflowY: "scroll",
          scrollbarWidth: "none",
        }}
      >
        <Table
          sx={{
            "& thead": {
              "& th": {
                color: "#949DAA",
                fontWeight: "500",
              },
            },
            "& tbody": {
              "& tr:hover": {
                backgroundColor: "#f7f7f7",
              },
              "& tr": {
                borderBottom: "none",
              },
            },
          }}
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>Project Name</StyledTableCell>
              <StyledTableCell>Start Date</StyledTableCell>
              <StyledTableCell>End Date</StyledTableCell>
              <StyledTableCell>Customer</StyledTableCell>
              <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                <strong
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  Cost ({renderCurrencyIcon('small')})
                </strong>
              </StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {details?.map((item, idx) => (
              <TableRow key={item.id}>
                <StyledTableCell
                  onClick={() => handleChange2(item)}
                  sx={{ cursor: "pointer" }}
                >
                  <Box display="flex" alignItems="center">
                    {item.project_image && item.project_image[0].image && (
                      <Box
                        component="img"
                        src={item.project_image[0].image}
                        alt="Project Icon"
                        sx={{
                          width: 45,
                          height: 45,
                          borderRadius: "8px",
                          border: "2px solid white",
                          boxShadow: "0px 4px 2.67px 0px #00000026",
                          marginRight: 1,
                        }}
                      />
                    )}
                    <div>
                      <Tooltip title={item?.name} arrow>
                        <p
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "150px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "600 !important",
                            transition: "color 0.3s",
                            color: "#0D0D0E",
                          }}
                        >
                          {item?.name?.length > 30
                            ? `${item.name.slice(0, 30)}...`
                            : item.name}
                        </p>
                      </Tooltip>
                      <Typography
                        sx={{
                          flex: 1,
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 1,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "normal",
                          fontSize: "13px",
                          fontWeight: "400",
                          transition: "color 0.3s",
                          color: "#949DAA",
                        }}
                      >
                        {item.project_type}
                      </Typography>
                    </div>
                  </Box>
                </StyledTableCell>

                <StyledTableCell>
                  <p
                    style={{
                      color: "#949DAA",
                      marginBottom: "2px",
                      fontWeight: "500",
                    }}
                  >
                    {moment(item?.start_date).format("MMM DD, YYYY")}
                  </p>{" "}
                </StyledTableCell>
                <StyledTableCell>
                  <p style={{ color: "#949DAA", fontWeight: "500" }}>
                    {moment(item?.end_date).format("MMM DD, YYYY")}
                  </p>
                </StyledTableCell>
                <StyledTableCell>
                  <Box display="flex" alignItems="center">
                    {item?.user_data && item?.user_data?.profile_url && (
                      <Box
                        component="img"
                        src={item?.user_data?.profile_url}
                        alt="Project Icon"
                        sx={{
                          width: 35,
                          height: 35,
                          borderRadius: "50%",
                          border: "2px solid white",
                          boxShadow: "0px 4px 2.67px 0px #00000026",
                          marginRight: 1,
                        }}
                      />
                    )}
                    {item?.user_data?.username}
                  </Box>
                </StyledTableCell>
                <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                  {`${formattedAmountWithoutAed(item?.cost)}`}
                </StyledTableCell>
                <StyledTableCell>
                  {/* <Typography
                    style={{
                      borderRadius: "34px",
                      padding: "4px 8px",
                      fontSize: "14px",
                      minWidth: "7ch",
                      width: "fit-content",
                      backgroundColor:
                        statusStyleArray.find(
                          (style) => style.status === item?.proposal_status
                        )?.backgroundColor || "transparent",
                      color:
                        statusStyleArray.find(
                          (style) => style.status === item?.proposal_status
                        )?.color || "black",
                      border: "none",
                      textAlign: "center",
                    }}
                  >
                    {getStatusDisplayText(item?.proposal_status)}
                  </Typography> */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      style={{
                        width: "15px",
                        height: "15px",
                        borderRadius: "50%",
                        backgroundColor:
                          statusStyleArray.find(
                            (style) => style.status === item?.proposal_status
                          )?.backgroundColor || "transparent",
                        border: "3px solid #e5e5e5",
                      }}
                    />
                    <Typography
                      style={{
                        fontSize: "14px",
                        marginLeft: "8px",
                        color: "#0D0D0E",
                      }}
                    >
                      {getStatusDisplayText(item?.proposal_status)}
                    </Typography>
                  </div>
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
